// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svgicon__hover-fill {
  fill: #707070;
}

.svgicon__hover-stroke {
  stroke: #707070;
}

.svgicon__hover-dash {
  stroke-dasharray: 2;
}

.svgicon__hover-show {
  visibility: hidden;
}

.svgicon__hover-container:hover .svgicon__hover-fill {
  fill: #2693ff;
}

.svgicon__hover-container:hover .svgicon__hover-stroke {
  stroke: #2693ff;
}

.svgicon__hover-container:hover .svgicon__hover-dash {
  stroke-dasharray: none;
}

.svgicon__hover-container:hover .svgicon__hover-show {
  visibility: visible;
}

.svgicon__hover-container:hover .svgicon__hover-hide {
  visibility: hidden;
}

.severity-icon--0 {
  color: var(--severity-color-0);
}

.severity-icon--10 {
  color: var(--severity-color-10);
}

.severity-icon--20 {
  color: var(--severity-color-20);
}

.severity-icon--30 {
  color: var(--severity-color-30);
}

.fa-safe-area {
  width: var(--fa-safe-area-size);
  height: var(--fa-safe-area-size);
  flex-grow: 0;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
}

.fa-safe-area--xs {
  --fa-safe-area-size: 1rem;
  font-size: .625rem;
}

.fa-safe-area--sm {
  --fa-safe-area-size: 1.25rem;
  font-size: .875rem;
}

.fa-safe-area--base {
  --fa-safe-area-size: 1.5rem;
  font-size: 1rem;
}

.fa-safe-area--lg {
  --fa-safe-area-size: 2rem;
  font-size: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/icons/styles.css","webpack://./services/frontend/app/components/icons/styles.css"],"names":[],"mappings":"AADA;ECEE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".svgicon__hover-fill {\n  fill: #707070;\n}\n\n.svgicon__hover-stroke {\n  stroke: #707070;\n}\n\n.svgicon__hover-dash {\n  stroke-dasharray: 2;\n}\n\n.svgicon__hover-show {\n  visibility: hidden;\n}\n\n.svgicon__hover-container:hover .svgicon__hover-fill {\n    fill: #2693ff;\n  }\n\n.svgicon__hover-container:hover .svgicon__hover-stroke {\n    stroke: #2693ff;\n  }\n\n.svgicon__hover-container:hover .svgicon__hover-dash {\n    stroke-dasharray: none;\n  }\n\n.svgicon__hover-container:hover .svgicon__hover-show {\n    visibility: visible;\n  }\n\n.svgicon__hover-container:hover .svgicon__hover-hide {\n    visibility: hidden;\n  }\n\n.severity-icon--0 {\n  color: var(--severity-color-0);\n}\n\n.severity-icon--10 {\n  color: var(--severity-color-10);\n}\n\n.severity-icon--20 {\n  color: var(--severity-color-20);\n}\n\n.severity-icon--30 {\n  color: var(--severity-color-30);\n}\n\n.fa-safe-area {\n  align-items: center;\n  justify-content: center;\n  width: var(--fa-safe-area-size);\n  height: var(--fa-safe-area-size);\n\n  /* disallow resizing when this is in flex container */\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.fa-safe-area--xs {\n  --fa-safe-area-size: 1rem;\n\n  font-size: 0.625rem;\n}\n\n.fa-safe-area--sm {\n  --fa-safe-area-size: 1.25rem;\n\n  font-size: 0.875rem;\n}\n\n.fa-safe-area--base {\n  --fa-safe-area-size: 1.5rem;\n\n  font-size: 1rem;\n}\n\n.fa-safe-area--lg {\n  --fa-safe-area-size: 2rem;\n\n  font-size: 1.25rem;\n}\n",".svgicon__hover-fill {\n  fill: #707070;\n}\n\n.svgicon__hover-stroke {\n  stroke: #707070;\n}\n\n.svgicon__hover-dash {\n  stroke-dasharray: 2;\n}\n\n.svgicon__hover-show {\n  visibility: hidden;\n}\n\n.svgicon__hover-container:hover .svgicon__hover-fill {\n  fill: #2693ff;\n}\n\n.svgicon__hover-container:hover .svgicon__hover-stroke {\n  stroke: #2693ff;\n}\n\n.svgicon__hover-container:hover .svgicon__hover-dash {\n  stroke-dasharray: none;\n}\n\n.svgicon__hover-container:hover .svgicon__hover-show {\n  visibility: visible;\n}\n\n.svgicon__hover-container:hover .svgicon__hover-hide {\n  visibility: hidden;\n}\n\n.severity-icon--0 {\n  color: var(--severity-color-0);\n}\n\n.severity-icon--10 {\n  color: var(--severity-color-10);\n}\n\n.severity-icon--20 {\n  color: var(--severity-color-20);\n}\n\n.severity-icon--30 {\n  color: var(--severity-color-30);\n}\n\n.fa-safe-area {\n  width: var(--fa-safe-area-size);\n  height: var(--fa-safe-area-size);\n  flex-grow: 0;\n  flex-shrink: 0;\n  justify-content: center;\n  align-items: center;\n}\n\n.fa-safe-area--xs {\n  --fa-safe-area-size: 1rem;\n  font-size: .625rem;\n}\n\n.fa-safe-area--sm {\n  --fa-safe-area-size: 1.25rem;\n  font-size: .875rem;\n}\n\n.fa-safe-area--base {\n  --fa-safe-area-size: 1.5rem;\n  font-size: 1rem;\n}\n\n.fa-safe-area--lg {\n  --fa-safe-area-size: 2rem;\n  font-size: 1.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
